import React, { useState, useEffect } from "react";
import Loading from "../../icons/Loading";
import ProductTile from "../../product-category/components/ProductTile";
import axios from "axios";
import { ACTION_FAVOURITE_PRODUCTS, ON_FAVOURITE_REMOVED } from "../../globals";
import FlickitySlider from "../../slider/slider";

const ElementProducts = (props) => {
  const [state, setState] = useState({
    loading: true,
    products: [],
  });

  const loadProducts = () => {
    axios.get(props.link).then((response) => {
      setState({
        loading: false,
        products: response.data,
      });
    });
  };

  useEffect(() => {
    loadProducts();
  }, []);

  if (state.loading) {
    return <Loading />;
  }

  return (
    <div>
      {state.products.length > 0 && (

        <div className="product-index__wrapper">
          <FlickitySlider
          options={{
            prevNextButtons: true,
            pageDots: false,
            loop: true,
            contain: true,
            freeScroll: true,
            groupCells: true
          }}
          >
          {state.products.map((product) => (
            <ProductTile product={product} key={"p" + product.id} />
          ))}
          </FlickitySlider>
        </div>
      )}
    </div>
  );
};

export default ElementProducts;
